import { useAuth } from '_/space-management/hooks/AuthContext';
import { useEventContext } from '_/space-management/hooks/EventContext';
import { useLocationContext } from '_/space-management/hooks/LocationContext';
import { useNotificationContext } from '_/space-management/hooks/NotificationsContext';
import { useOrganizationContext } from '_/space-management/hooks/OrganizationContext';import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import {
  FlatList,
  RefreshControl,
  View,
} from 'react-native';

import OfficesList from './OfficesList';
import TodayReservations from './TodayReservations';

export default function Home() {
  const { member, updateMember } = useAuth();
  const { getOrganization, getMember } = useOrganizationContext();
  const { getLocations, isLoading } = useLocationContext();
  const { getTodayEvents } = useEventContext();
  const { getNotReadNotifications } = useNotificationContext();
  const { t } = useTranslation();

  useEffect(() => {
    if (member) {
      getOrganization(member?.organizationId);
    }
  }, [getOrganization, member]);

  return (
    <View style={{ flex: 1 }}>

      <FlatList
        refreshControl={
          <RefreshControl
            refreshing={isLoading}
            onRefresh={async () => {
              if (member) {
                await getOrganization(member?.organizationId);
                const [reloadMember] = await getMember(
                  member.userId,
                  member.organizationId
                );
                if (reloadMember) await updateMember(reloadMember);
              }
              await getLocations();
              await getTodayEvents();
              await getNotReadNotifications();
            }}
          />
        }
        data={['1']}
        keyExtractor={(item) => item}
        renderItem={() => (
          <>
            <TodayReservations />
            <OfficesList />
          </>
        )}
      />
    </View>
  );
}
